module.exports = __webpack_public_path__ + "static/media/tops.f1600c1b.png";